export default __webpack_public_path__ + "static/596-9a4d662f97f8c6e64c7f2375a6bf5b4f.gif";